import React from 'react';
import {
  ELIGIBILITY, EMPLOYMENT, HOUSEHOLD, MORE_DETAILS, MOVE_DETAILS, PERSONAL_INFO,
} from '@tmap/mmm-core/commonApp/funnelCategories';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import isWaitlist from '../../lib/incentive/isWaitlist';

function CommonAppSubHead({ stage, incentive = {} }) {
  const headlineText = () => {
    switch (stage) {
      case ELIGIBILITY:
        if (isWaitlist(incentive)) return `${incentive.locationText}’s program is either paused or in progress, but you can get a head start by applying to be on the waitlist.`;
        return `Before we get started, let’s make sure you meet the minimum requirements for ${incentive.locationText}'s program.`;
      case PERSONAL_INFO:
        return `Share your information so ${incentive.locationText} may contact you.`;
      case MOVE_DETAILS:
        return `Give ${incentive.locationText} some details about your interest, and what is important to you.`;
      case HOUSEHOLD:
        return 'Tell us a bit about your household.';
      case EMPLOYMENT:
        return `Give ${incentive.locationText} a sense of your profession and background.`;
      case MORE_DETAILS:
        return `Tell ${incentive.locationText} why they should select you.`;
      default: return '';
    }
  };
  return <Typography variant='body2' color='textSecondary'>{headlineText()}</Typography>;
}

export default CommonAppSubHead;
